// Mock data pour Sensai Yang

export const portfolioItems = [
  {
    id: 1,
    name: "Julie Masse",
    category: "Bien-être",
    description: "Site vitrine élégant pour coach bien-être/thérapeute avec possibilité de mettre un système de prise de RDV.",
    image: "https://customer-assets.emergentagent.com/job_fast-websites-agency/artifacts/ipy7t9ul_Julie%20Masse.png",
    link: "https://juliemasse.online"
  },
  {
    id: 2,
    name: "Just'Une Dalle",
    category: "Food Truck",
    description: "Site moderne pour food truck avec menu interactif",
    image: "https://customer-assets.emergentagent.com/job_fast-websites-agency/artifacts/m1fr4258_Capture%20d%E2%80%99e%CC%81cran%202026-02-12%20a%CC%80%2020.30.56.png",
    link: "https://foodtruckmodel.online"
  },
  {
    id: 3,
    name: "Anaé Vilnor",
    category: "Photographie",
    description: "Portfolio photographique immersif et artistique avec galerie inspirée des galeries d'art",
    image: "https://customer-assets.emergentagent.com/job_fast-websites-agency/artifacts/scmxbddd_Capture%20d%E2%80%99e%CC%81cran%202026-02-12%20a%CC%80%2019.57.25.png",
    link: "https://anae-vilnor.online"
  },
  {
    id: 4,
    name: "AquaPlomberie",
    category: "Artisan",
    description: "Site professionnel pour artisan plombier orienté pour les appels en urgence",
    image: "https://customer-assets.emergentagent.com/job_fast-websites-agency/artifacts/z9wrx82o_Capture%20d%E2%80%99e%CC%81cran%202026-02-12%20a%CC%80%2019.55.12.png",
    link: "https://aquaplomberie-lyon.online"
  }
];

export const features = [
  {
    title: "Livraison en 24–48h",
    description: "Votre site en ligne rapidement, sans compromis sur la qualité"
  },
  {
    title: "Aucun abonnement imposé",
    description: "Un paiement unique, pas de frais mensuels cachés"
  },
  {
    title: "Site 100% propriété du client",
    description: "Vous êtes propriétaire de votre site, tous les accès vous appartiennent"
  },
  {
    title: "Hébergement au nom du client",
    description: "Votre hébergement est à votre nom, vous gardez le contrôle"
  },
  {
    title: "Transparence totale",
    description: "Communication claire à chaque étape du projet"
  },
  {
    title: "Optimisé mobile",
    description: "Design responsive parfait sur tous les appareils"
  }
];

export const offers = [
  {
    id: 1,
    name: "Offre Essentielle",
    price: "350€",
    icon: "zap",
    features: [
      "Site complet Standard",
      "Page d'accueil professionnelle",
      "Formulaire de contact e-mail + téléphone cliquable",
      "Mise en ligne incluse",
      "Retouches essentielles mineures sans frais",
      "Aucun abonnement requis"
    ],
    description: "Parfait pour une image professionnelle, épurée et efficace",
    popular: false
  },
  {
    id: 2,
    name: "Offre Professionnelle",
    price: "550€",
    icon: "star",
    features: [
      "Tous les avantages de l'offre essentielle",
      "Site complet Premium (5 sections/pages)",
      "Formulaire + Bouton d'appel/Prise de RDV dynamique",
      "Intégration Google Maps/Prise de RDV",
      "Retouches pendant 7 jours sans frais",
      "Aucun abonnement requis"
    ],
    description: "Idéal pour une image professionnelle forte et parlante",
    popular: true
  },
  {
    id: 3,
    name: "Offre Prestige",
    price: "890€",
    icon: "gem",
    features: [
      "Tous les avantages de l'offre Professionnelle et Essentielle",
      "Site complet d'excellence (6–8 pages)",
      "Optimisation conversion",
      "Votre image de marque optimisée (couleurs, mise en page)",
      "Retouches pendant 14 jours sans frais",
      "Adresse e-mail professionnelle offerte",
      "Nom de domaine personnel offert la première année (votresiteexemple.com)",
      "Aucun abonnement requis"
    ],
    description: "Pour une entreprise qui cherche un kit complet pour vraiment se démarquer",
    popular: false
  }
];

export const trustText = {
  title: "Une approche transparente",
  content: "Pas d'agence offshore. Pas de frais cachés. Pas d'abonnement surprise. Vous payez votre site. Il vous appartient."
};

export const contactInfo = {
  phone: "06 26 15 09 87",
  phoneLink: "0626150987",
  email: "contact@sensai-yang-pro.com",
  whatsapp: "33626150987",
  whatsappLink: "https://wa.me/33626150987"
};
